import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FloatingChatContextType {
  isOpen: boolean;
  preparationId?: string;
  openChat: (preparationId?: string) => void;
  closeChat: () => void;
  toggleChat: () => void;
}

const FloatingChatContext = createContext<FloatingChatContextType | undefined>(undefined);

export const useFloatingChat = () => {
  const context = useContext(FloatingChatContext);
  if (!context) {
    throw new Error('useFloatingChat must be used within FloatingChatProvider');
  }
  return context;
};

interface FloatingChatProviderProps {
  children: ReactNode;
}

export const FloatingChatProvider: React.FC<FloatingChatProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [preparationId, setPreparationId] = useState<string | undefined>(undefined);

  const openChat = (prepId?: string) => {
    setPreparationId(prepId);
    setIsOpen(true);
  };

  const closeChat = () => {
    setIsOpen(false);
    // Clear preparationId after animation completes
    setTimeout(() => setPreparationId(undefined), 300);
  };

  const toggleChat = () => {
    if (isOpen) {
      closeChat();
    } else {
      openChat();
    }
  };

  return (
    <FloatingChatContext.Provider
      value={{
        isOpen,
        preparationId,
        openChat,
        closeChat,
        toggleChat,
      }}
    >
      {children}
    </FloatingChatContext.Provider>
  );
};
